"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import Container from "@/components/Container";
import type {ArrowsBlock as ArrowsBlockProps} from "@/payload-types";
import "./index.scss";
import Image from "next/image";
import type React from "react";
import {useState} from "react";
import {CMSLink} from "@/components/Link";
import RichText from "@/components/RichText";

export const ArrowsBlock: React.FC<ArrowsBlockProps> = (props) => {
	const { arrows, link, enableLink, title } = props;
	const [activeTab, setActiveTab] = useState(0);
	const activeArrow = arrows?.[activeTab];

	return (
		<div className="arrows_block">
			<Container>
				{title && <h2>{title}</h2>}
				<div className="banner_arrows">
					{arrows?.map((arrow, index) => (
						<div
							className="banner_arrows-item"
							// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
							key={index}
						>
							<button
								type="button"
								onClick={() => {
									setActiveTab(index);
								}}
								className={activeTab === index ? "active" : ""}
							>
								{activeTab === index ? (
									<Image
										width={300}
										height={50}
										alt="Arrow"
										src="/assets/arrow.svg"
									/>
								) : (
									<Image
										width={300}
										height={50}
										alt="Arrow"
										src="/assets/arrow-right-light.svg"
									/>
								)}
							</button>
							<p>{arrow.title}</p>
						</div>
					))}
				</div>
				{activeArrow && (
					<div className="arrow_content">
						{activeArrow.richText && <RichText data={activeArrow.richText} />}
					</div>
				)}
				{enableLink && (
					<div className="banner_arrows-cta">
						{link && <CMSLink {...link} />}
					</div>
				)}
			</Container>
		</div>
	);
};
